import React, { useContext } from "react";
import { useIntl } from "umi";
import { getLanguage } from "@home/utils/common";
import { LANGUAGE_EN } from "@home/_config/config";
import Abnormal from "@home/components/Abnormal";
import SvgIcon from "@home/components/SvgIcon";
import CommonBubble from "@home/components/CommonBubble";
import { StudioContext } from "@home/pages/studio/context";
import { InsightsData } from "../../type";
import classnames from 'classnames';
import "./index.scss";
interface Insights {
  className?: string;
  titleEn: string;
  titleCn: string;
  loading: boolean;
  error: boolean;
  insightsData: InsightsData;
  setShowModal:(boolean: boolean)=>void;
  setInsightsData: (data: InsightsData) => void;
  normalNoContentEn: string;
  normalNoContentCn: string;
  setEditModalTitle: (title: string) => void;
}

export default function Insights(props: Insights) {
  const { className, titleEn, titleCn, loading, error, insightsData, setShowModal, normalNoContentEn, normalNoContentCn, setEditModalTitle } = props;
  const { formatMessage, locale } = useIntl();
  const isEN = locale === LANGUAGE_EN;
  const { editPermission } = useContext(StudioContext);

  let content;

  if (insightsData) {
    content = <div className= {classnames('dbh-insights-container', className)} >
      <div style={{ width: "100%" }}>
        <div className="dbh-insights-title">
          <span>{getLanguage(isEN, titleEn, titleCn)}</span>
          {editPermission && (
            <CommonBubble content={getLanguage(isEN, "Edit", "编辑")}>
              <span
                style={{ marginRight: "8px", cursor: "pointer" }}
                onClick={() => {
                  setShowModal(true);
                  setEditModalTitle(formatMessage({id: 'dbh_studio_edit_insights'}));
                }}
              >
                <SvgIcon
                  className="dbh-studio-appendix-edit-icon"
                  type="edit-icon"
                />
              </span>
            </CommonBubble>
          )}
        </div>
        <div className="dbh-insights-content">
          <span dangerouslySetInnerHTML={{ __html: insightsData?.content }}></span>
        </div>
      </div>
    </div>;
  } else if (editPermission) {
    content = (
      <div className="dbh-insights-no-content">
        {/* <span className="dbh-insights-title">{getLanguage(isEN, titleEn, titleCn)}</span> */}
        <div className = "dbh-insights-no-content-text">
          {formatMessage({ id: 'dbh_studio_no_content1' })},&nbsp;
          <span
            className="dbh-appendix-no-content-add-btn"
            onClick={() => {
              setShowModal(true);
              setEditModalTitle(formatMessage({id: 'dbh_studio_add_insights'}));
            }}
          >
            {formatMessage({ id: 'dbh_studio_add__an_insights' })}
          </span>
        </div>
      </div>
    );
  } else {
    content = (
      <div className="dbh-insights-no-content">
        {getLanguage(isEN, normalNoContentEn, normalNoContentCn)}
      </div>
    );
  }

  return (
    <>
      <Abnormal
        isLoading={loading}
        isError={error}
        classNames="dbh-insights-abnormal"
        component={content}
      />
    </>
  );
}
